import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var Resyndication =
/*#__PURE__*/
function (_BaseData) {
  _inherits(Resyndication, _BaseData);

  function Resyndication() {
    _classCallCheck(this, Resyndication);

    return _possibleConstructorReturn(this, _getPrototypeOf(Resyndication).call(this, "Resyndication"));
  }

  _createClass(Resyndication, [{
    key: "CreateResyndicationModel",
    value: function () {
      var _CreateResyndicationModel = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/Resyndication/CreateResyndicationModel"));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function CreateResyndicationModel() {
        return _CreateResyndicationModel.apply(this, arguments);
      }

      return CreateResyndicationModel;
    }()
  }, {
    key: "CreateResyndicationRow",
    value: function () {
      var _CreateResyndicationRow = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(projectId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/Resyndication/CreateResyndicationRow/".concat(projectId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function CreateResyndicationRow(_x) {
        return _CreateResyndicationRow.apply(this, arguments);
      }

      return CreateResyndicationRow;
    }()
  }, {
    key: "GetResyndicationInfo",
    value: function () {
      var _GetResyndicationInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(projectId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/Resyndication/GetResyndicationInfo/".concat(projectId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function GetResyndicationInfo(_x2) {
        return _GetResyndicationInfo.apply(this, arguments);
      }

      return GetResyndicationInfo;
    }()
  }, {
    key: "GetResyndicationHistoryByProperty",
    value: function () {
      var _GetResyndicationHistoryByProperty = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(projectId, latest) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/Resyndication/GetResyndicationHistoryByProperty/".concat(projectId, "/").concat(latest)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function GetResyndicationHistoryByProperty(_x3, _x4) {
        return _GetResyndicationHistoryByProperty.apply(this, arguments);
      }

      return GetResyndicationHistoryByProperty;
    }()
  }, {
    key: "CreateResyndication",
    value: function () {
      var _CreateResyndication = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(resyindaication) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.post("/api/Resyndication/CreateResyndication", resyindaication));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function CreateResyndication(_x5) {
        return _CreateResyndication.apply(this, arguments);
      }

      return CreateResyndication;
    }()
  }]);

  return Resyndication;
}(BaseData);

export default new Resyndication();